export default __webpack_public_path__ + "static/media/yggdrasil.6333fa1f.png";